import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';

const PRIMARY_CLASS = 'inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] px-5 py-2.5 border border-ink bg-ink text-canvas hover:opacity-90 transition-opacity';
const SECONDARY_CLASS = 'ml-3 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.18em] px-5 py-2.5 border border-line text-soft hover:border-ink hover:text-ink transition-colors';

/**
 * Empty state guidato — sostituisce i div vuoti con un CTA chiaro.
 *
 * Props:
 *  - icon:    elemento React opzionale
 *  - title:   string
 *  - desc:    string
 *  - actionLabel: string (testo del bottone)
 *  - actionTo:    string (route)  — usa Link
 *  - actionOnClick: () => void   — alternativa a actionTo
 *  - secondary:   { label, to? , onClick? } (opzionale)
 *  - testid:  data-testid
 */
export default function EmptyState({
  icon,
  title,
  desc,
  actionLabel,
  actionTo,
  actionOnClick,
  secondary,
  testid = 'empty-state',
}) {
  const primaryContent = (
    <><MessageCircle size={13} strokeWidth={1.5} /> {actionLabel}</>
  );
  const primary = actionLabel && (actionTo ? (
    <Link to={actionTo} className={PRIMARY_CLASS} data-testid={`${testid}-action`}>{primaryContent}</Link>
  ) : (
    <button onClick={actionOnClick} className={PRIMARY_CLASS} data-testid={`${testid}-action`}>{primaryContent}</button>
  ));
  const secondaryBtn = secondary && (secondary.to ? (
    <Link to={secondary.to} className={SECONDARY_CLASS} data-testid={`${testid}-secondary`}>{secondary.label}</Link>
  ) : (
    <button onClick={secondary.onClick} className={SECONDARY_CLASS} data-testid={`${testid}-secondary`}>{secondary.label}</button>
  ));

  return (
    <div
      className="border border-dashed border-line py-16 px-8 text-center"
      data-testid={testid}
    >
      {icon && <div className="inline-flex mb-4 text-mute">{icon}</div>}
      <h3 className="font-display text-2xl tracking-tight mb-2">{title}</h3>
      {desc && <p className="font-body text-sm text-soft max-w-md mx-auto mb-6">{desc}</p>}
      <div className="inline-flex items-center">
        {primary}
        {secondaryBtn}
      </div>
    </div>
  );
}
